'use client'

import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { isStorefrontPreviewPath } from '@/modules/helpers/storefrontPreview'

const APPLICATION_ID = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || ''
const CLIENT_TOKEN = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || ''
const SERVICE = process.env.NEXT_PUBLIC_DATADOG_SERVICE || ''
const VERCEL_BRANCH = process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL
const VERSION = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || ''
let ENVIRONMENT = process.env.NEXT_PUBLIC_VERCEL_ENV || 'development'

if (ENVIRONMENT === 'preview' && VERCEL_BRANCH) {
    ENVIRONMENT = VERCEL_BRANCH.split('-git-')[1].split('.vercel.app')[0]
}

// Previews are sandboxed, so their storage failures are expected noise.
const isPreviewDocument =
    typeof window !== 'undefined' &&
    isStorefrontPreviewPath(window.location.pathname)

if (!isPreviewDocument) {
    datadogRum.init({
        clientToken: CLIENT_TOKEN,
        applicationId: APPLICATION_ID,
        site: 'datadoghq.com',
        service: SERVICE,
        env: ENVIRONMENT,
        version: VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    })

    datadogLogs.init({
        clientToken: CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: SERVICE,
        env: ENVIRONMENT,
        version: VERSION,
        forwardConsoleLogs: 'all',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    })
}

export default function DatadogInit() {
    // Render nothing - this component is only included so that the init code
    // above will run client-side
    return null
}
